<div class="row">
    <div class="col-12">
        <div class="card-box table-responsive">
            <h4 class="header-title mb-3">Administración Ticket PAC's</h4>
            <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                    <div class="col-sm-12">
                        <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input type="text" tabindex="0"></div>
                        <table class="table table-hover m-0  dt-responsive nowrap" cellspacing="0" width="100%" *ngIf="companyService.companyList && companyService.companyList.length" id="dataTableCompany">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>{{ "empresas.tablaEmpresa.Nit" | translate }}</th>
                                    <th>{{ "empresas.tablaEmpresa.Nombre" | translate }}</th>
                                    <th>{{ "empresas.tablaEmpresa.Telefono" | translate }}</th>
                                    <th>{{ "empresas.tablaEmpresa.CorreoElectronico" | translate }}</th>
                                    <th>{{ "empresas.tablaEmpresa.Vip" | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let company of companyService.companyList; let i = index">
                                    <td>{{company.idAdmEmpresa }}</td>
                                    <td>{{company.nit}}</td>
                                    <td>{{company.nombre}}</td>
                                    <td>{{company.telefono}}</td>
                                    <td>{{company.emailRepresentante}}</td>
                                    <td>{{company.vip}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>